module.exports = __webpack_public_path__ + "img/climbing-table-icon.79231b46.svg";